import { render, staticRenderFns } from "./SettlementDetails.vue?vue&type=template&id=41ec04b4&"
import script from "./SettlementDetails.vue?vue&type=script&lang=js&"
export * from "./SettlementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports